import { render } from "./rightConcent.vue?vue&type=template&id=4a46e84e&scoped=true&lang=true"
import script from "./rightConcent.vue?vue&type=script&lang=js"
export * from "./rightConcent.vue?vue&type=script&lang=js"

import "./rightConcent.vue?vue&type=style&index=0&id=4a46e84e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a46e84e"]])

export default __exports__